import { useState } from "react";
import { faqList } from "@/mocks/celebrityData";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="mx-auto max-w-4xl px-4 py-16 md:px-6" aria-label="常见问题">
      <div className="text-center">
        <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-crimson-500">
          <i className="ri-question-line" aria-hidden="true"></i> 解答你的疑问
        </span>
        <h2 className="mt-2 font-serif text-3xl font-black text-ink-950 md:text-4xl">常见问题</h2>
      </div>

      <div className="mt-8 space-y-3">
        {faqList.map((f, i) => {
          const isOpen = open === i;
          return (
            <div
              key={f.q}
              className="overflow-hidden rounded-2xl border border-paper-200 bg-white"
            >
              <button
                onClick={() => setOpen(isOpen ? null : i)}
                aria-expanded={isOpen}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
              >
                <h3 className="flex items-center gap-3 font-serif text-base font-bold text-ink-900 md:text-lg">
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-crimson-100 text-xs font-bold text-crimson-500">
                    {i + 1}
                  </span>
                  {f.q}
                </h3>
                <i
                  className={`ri-add-line shrink-0 text-lg text-ink-400 transition-transform duration-300 ${
                    isOpen ? "rotate-45 text-crimson-500" : ""
                  }`}
                  aria-hidden="true"
                ></i>
              </button>
              <div
                className={`grid transition-all duration-300 ${
                  isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                }`}
              >
                <div className="overflow-hidden">
                  <p className="px-5 pb-5 pl-[64px] text-sm leading-relaxed text-ink-600">{f.a}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}